var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 1.8H14.4V0H12.6V1.8H5.4V0H3.6V1.8H2.7C1.98392 1.8 1.29716 2.08446 0.790812 2.59081C0.284464 3.09716 0 3.78392 0 4.5V15.3C0 16.0161 0.284464 16.7028 0.790812 17.2092C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.2092C17.7155 16.7028 18 16.0161 18 15.3V4.5C18 3.78392 17.7155 3.09716 17.2092 2.59081C16.7028 2.08446 16.0161 1.8 15.3 1.8ZM7.90711 13.6929C7.51658 14.0834 6.88342 14.0834 6.49289 13.6929L4.6845 11.8845C4.33371 11.5337 4.33271 10.9653 4.68226 10.6133C5.03356 10.2595 5.60546 10.2585 5.958 10.611L7.2 11.853L11.592 7.461C11.9445 7.10846 12.5164 7.10947 12.8677 7.46326C13.2173 7.81528 13.2163 8.38371 12.8655 8.7345L7.90711 13.6929Z",
    fill: "#4A81E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment1);
export default __webpack_public_path__ + "static/media/appointment1.00d7cd3d58f9721d0cf1359385edd8a3.svg";
export { ForwardRef as ReactComponent };